import type { FormFactor } from "@/features/feed/contract"
import type { Locale } from "@/i18n/locales"
import type { SearchParamsInput } from "@/lib/services/search/search"
import { feedPreviewToken, FEED_PREVIEW_PARAM, FEED_PREVIEW_SEGMENT_PARAM } from "@/platform/experiments/feed-preview"

export interface FeedViewContext {
  preview?: string
  previewSegment?: string
  formFactor?: FormFactor
  previewEffectiveAt?: string
  locale?: Locale
}

export const feedViewContext = (params: SearchParamsInput = {}): FeedViewContext => {
  const get = (key: string) => (typeof params.get === "function" ? params.get(key) : (params as Record<string, unknown>)[key])
  const token = get(FEED_PREVIEW_PARAM)
  const preview = feedPreviewToken(typeof token === "string" ? token : undefined)
  if (!preview) return {}
  const segment = get(FEED_PREVIEW_SEGMENT_PARAM)
  const device = get("feedPreviewDevice")
  const at = get("feedPreviewAt")
  return {
    preview,
    previewSegment: typeof segment === "string" && ["NEW", "EXISTING", "CROSS_SOLD"].includes(segment) ? segment : "NEW",
    formFactor: device === "MOBILE" || device === "DESKTOP" ? device : undefined,
    previewEffectiveAt: typeof at === "string" && Number.isFinite(Date.parse(at)) ? new Date(at).toISOString() : undefined,
  }
}

export const feedContextQuery = (context: FeedViewContext): Record<string, string> =>
  context.preview
    ? {
        [FEED_PREVIEW_PARAM]: context.preview,
        ...(context.previewSegment ? { [FEED_PREVIEW_SEGMENT_PARAM]: context.previewSegment } : {}),
        ...(context.formFactor ? { feedPreviewDevice: context.formFactor } : {}),
        ...(context.previewEffectiveAt ? { feedPreviewAt: context.previewEffectiveAt } : {}),
      }
    : {}
